export default __webpack_public_path__ + "img/224fdcb461e975d6cd559cbbd3b8e54e.jpg";